import React from 'react';
import './CollapsibleTableCSS.css';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faChevronUp} from '@fortawesome/free-solid-svg-icons'

import AnimateHeight from 'react-animate-height';


export default class RatesDirectionsComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: this.props.open,
            heading: null, // []
            rows: null, // [[]]

        };
    }

    renderHeading() {
        const shouldRender = this.props.heading !== null && this.props.heading !== undefined;
       // console.log(shouldRender)
        if (shouldRender) {
            return this.props.heading.map( (item, idx) => <th className={idx > 0 ? "text-center" : ""} key={item+idx} dangerouslySetInnerHTML={{__html: item}}/> )
        }
        return null;
    }

    renderRows() {
        const shouldRender = this.props.rows !== null && this.props.rows !== undefined;
       // console.log(shouldRender)
        if (shouldRender) {
            return this.props.rows.map( (item, idx) => {
               // console.log(item);
               return  <tr key={idx}>{
                  item.map((child, index) => {
                   return   <td className={ index > 0 ? "text-center collapsible-table-td" : ""} key={index} dangerouslySetInnerHTML={{__html: child}}/>
                  })}
                </tr> })
        }
        return null;
    }

    toggleOpen = () => {
        this.setState(Object.assign(this.state, {open: !this.state.open}));
    };


    render() {
        return(<div className={this.props.className}>
            <div className={"col-12 d-flex align-items-center collapsible-table-title-div p-2"} onClick={this.toggleOpen}>
                <span style={{width: '95%'}}>{this.props.title}</span>
                <FontAwesomeIcon style={{transition: '.200s ease-in-out'}} className={"fa-style-adj"} icon={faChevronUp} rotation={this.state.open ? null : 180}/>
            </div>

            <div className={"col-12 px-0"}>
            <AnimateHeight  duration={250} height={this.state.open ? 'auto' : '0'}>
            <table className="table table-striped">
                <thead>
                <tr>
                    {this.renderHeading()}
                    {/*{this.props.heading === null || undefined ? null : this.props.heading.map( (item, idx) => <th key={item+idx}>{item}</th> )}*/}
                </tr>
                </thead>
                <tbody>
                {this.renderRows()}

                </tbody>
            </table>
            </AnimateHeight>
            </div>
        </div>)
    }
}
